import { Timestamp } from "firebase/firestore";

export interface Program {
  coach: string
  end: string;
  start: string;
  formula: ProgramFormula
  id: string
  isTemplate: boolean
  isArchived: boolean,
  description: string;
  participant: string;
  type: ProgramType,
  title: string,
  state: StateType,
  language: string
  notes?: string
}

export interface GenericState {
  id: string,
  date: Timestamp,
  comment: string,
  type: StateType
  user: string | null
}

export enum StateType {
  PLANNED = 'PLANNED',
  STARTED = 'STARTED',
  ENDED = 'ENDED',
  SUSPENDED = 'SUSPENDED',
  COMPLETED = 'COMPLETED',
  RESUMED = 'RESUMED',
  ARCHIVED = 'ARCHIVED'
}


// enum mappings
export enum ActivityType {
  INDIVIDUAL_COACHING = 'INDIVIDUAL_COACHING',
  WEBINAR = 'WEBINAR',
  CLASSIC_TRAINING = 'CLASSIC_TRAINING',
  WORKSHOP = 'WORKSHOP',
  SELF_LEARNING = 'SELF_LEARNING',
  ASSESMENT = 'ASSESMENT',
}

export enum ProgramFormula {
  ALGEMEEN_OPZEG = 'ALGEMEEN_OPZEG',
  ALGEMEEN_VERBREKING = 'ALGEMEEN_VERBREKING',
  BIJZONDER = 'BIJZONDER',
  MEDISCH_OVERMACHT = 'MEDISCH_OVERMACHT',
  VRIJWILLIG = 'VRIJWILLIG',
  COLLECTIEF = 'COLLECTIEF',
  OTHER = 'OTHER'
}

export enum ProgramType {
  GROUP = 'GROUP',
  INDIVIDUAL = 'INDIVIDUAL',
  MIXED = 'MIXED'
}

export interface Phase {
  id?: string,
  title: string;
  description: string;
  hours: number;
  start: Timestamp,
  end: Timestamp,
  index: number
  programId: string,
  // New fields for content/webinar hours (refactor)
  screencastHours?: number;  // Planned screencast hours for this phase
  webinarHours?: number;     // Planned webinar hours for this phase
}

export interface Activity {
  id?: string,
  type: ActivityType,
  name: string,
  plannedHours: number,
  description: string;
  isOnline: boolean,
  required: boolean,
  start: Date | string,
  end: Date | null,
  phaseId: string,
  // New field to mark legacy screencast/webinar activities
  isContentActivity?: boolean;  // Excludes from normal activity calculations
}

export interface ActualActivity {
  id?: string,
  actualHours: number,
  date: Timestamp,
  comment: string,
  participantPresent: boolean,
  participantConfirmed: boolean
  confirmationSkipped?: boolean,
  activityId: string,
  skipActivityReminders?: boolean,
  isWebinar?: boolean; // Existing field for webinar marking
}


export enum EMAIL_NOTIFICATION_TYPE {
  COACH_CREATED_ACTIVITY = 'COACH_CREATED_ACTIVITY'
}

export interface EmailNotificationSetting {
  id: string;
  UserId: string;
  type: EMAIL_NOTIFICATION_TYPE;
}

export enum CONTENT_TYPE {
  VIDEO = "VIDEO",
  YOUTUBE_VIDEO = "YOUTUBE_VIDEO",
  PDF = 'PDF'
}

export interface ContentItem {
  id: string;
  title: string;
  type: CONTENT_TYPE;
  user: string;
  property: string;
  language?: string;
  archived: boolean;
  // New field for flexible hour values
  hourValue?: number;  // Hours credited for completion (default: 1)
}

export interface ContentAssignment {
  id?: string;
  user: string;
  requestedBy: string;
  completed: boolean;
  contentId: string;
  phase?: string;
  hoursAdded: boolean;
  actualActivityId?: string;  // Legacy - links to old activity system
  // New fields for refactored content system
  autoCompleteHours?: boolean;    // If true, hours completed on assignment (not viewing)
  viewedAt?: Timestamp;           // When participant first viewed the content
  completedAt?: Timestamp;        // When marked as completed
  legacy?: boolean;               // Marks old system records (has actualActivityId)
  hourValue?: number;             // Snapshot of content-item.hourValue at assignment time
}

export enum EVENT_TYPE {
  WEBINAR = "WEBINAR",
}

export interface CalendarEvent {
  id?: string;
  title: string;
  start: Timestamp;
  end: Timestamp;
  coach: string;
  createdBy: string;
  type: EVENT_TYPE;
  teamsUrl: string;
  description: string,
  surveySent?: boolean
  promoInviteSent?: boolean
  language?: string;
}

export interface Mail {
  from: string;
  to: string[];
  cc: string[];
  subject: string;
  body: string;
  sent: boolean;
  error?: any;
  date: Timestamp;
}

// New interfaces for content/hours refactor
export interface ContentStats {
  totalHours: number;       // Sum of all assigned content hourValues
  completedHours: number;   // Sum of completed content hourValues
  viewedCount: number;      // Count of content viewed
  assignedCount: number;    // Total assignments
}

export interface PhaseHoursBreakdown {
  activityHours: number;     // Hours from regular activities (excluding content activities)
  screencastHours: number;   // Hours from content-assignments in this phase
  webinarHours: number;      // Hours from webinar registrations in this phase
}